import { render, staticRenderFns } from "./ButtonNavigation.vue?vue&type=template&id=1c1d2fc4&scoped=true"
import script from "./ButtonNavigation.vue?vue&type=script&lang=ts"
export * from "./ButtonNavigation.vue?vue&type=script&lang=ts"
import style0 from "./ButtonNavigation.vue?vue&type=style&index=0&id=1c1d2fc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1d2fc4",
  null
  
)

export default component.exports